import COMPONENT_MAP from '../Repository/Components.js';

const NoteDetailPopup=({popupCallBack,rowId,parent,userData,application,fromPopup=false})=>{

    const pageCallback=async(action,args)=>{
        popupCallBack(action,args);
    }

    const renderPageDetail=()=>{
        const Component=COMPONENT_MAP['PageDetail'];
        return Component?(
            <Component
                recordId={rowId}
                userData={userData}
                application={application}
                entityType={'Note'}
                entityParams={['_context='+['parent_field_name='+parent.parent_field_name,'parent_field_value='+parent.parent_field_value,'parent_name='+parent.parent_name],'_lang='+application.globalData.lang]}
                file={'NoteDetailPopup.js'}
                titleLabel={rowId?application.getLocale("FieldNote"):application.getLocale("PopupTitleNewNote")}
                pageCallback={pageCallback}
                pageTabs={[]}
                isPopUp={true}
                fromPopup={fromPopup}
            />
        ):null; 
    };
    return (renderPageDetail());
}

export default NoteDetailPopup;